import {
  DAY,
  LIST,
  PLUS,
  TIMESHEET_CALENDAR,
  TIMESHEET_CARD,
  TIMESHEET_TABLE,
  TIMESHEET_WEEK,
} from "icons";
import { HEADER_CONTENT_PORTAL_ID, UI_ACTION_PORTAL_ID } from "utils";
import { Link, useLocation } from "react-router-dom";
import { Button } from "ui";
import { Icon } from "components";
import NavSlot from "@/components/navigation/tabs";
import { Portal } from "radix-ui";
import { usePortal } from "hooks";
import { TimesheetHeader } from "../components/header";

export default function DraftTimesheetLogLayout({ children, headerContent }) {
  const { pathname } = useLocation();
  const navItems = [
    {
      id: 1,
      path: "/timesheet/draft",
      label: "Day",
      icon: TIMESHEET_CARD,
    },
    {
      id: 2,
      path: "/timesheet/draft/week",
      label: "Dashboard",
      icon: TIMESHEET_WEEK,
    },
    {
      id: 3,
      path: "/timesheet/draft/calendar",
      label: "Calendar",
      icon: TIMESHEET_CALENDAR,
    },

    {
      id: 4,
      path: "/timesheet/draft/table",
      label: "Table",
      icon: LIST,
    },
  ];
  const uiActionPortal = usePortal({
    elementId: UI_ACTION_PORTAL_ID,
    ownerId: "draft-timesheet-root",
  });

  return (
    <div className="w-full">
      <TimesheetHeader>
        {headerContent}
        <div id={HEADER_CONTENT_PORTAL_ID} />
        <NavSlot navItems={navItems} />
      </TimesheetHeader>
      {children}
    </div>
  );
}
